import { useState, useEffect, useRef, useLayoutEffect } from 'react';
import { Row, Col, Form, Input, Checkbox, Tabs, Divider, Select } from 'antd';
import CrudButtons from "../../components/CrudButtons/CrudButtons";
import { useSelector, useDispatch } from 'react-redux';
import Tables from "../../components/Table/Tables"
import PageHeader from '../../components/PageHeader/PageHeader';
import { getCountry, addCountry, deleteCountry, updateCountry, } from '../../redux/actions/country.action';
import { logColumns, countryColumns, salePersonHierarchyColumns } from "../../utils/cols";
import { getLog } from "../../redux/actions/log.action"
import { getRights } from "../../redux/actions/userRights.action";
import "../Style/style.css";
import notification from '../../utils/notification'
import { ReadCookie } from '../../utils/readCookie';
import { TabTitle } from '../../utils/GeneralFunction';
import { loadSalePerson } from '../../redux/actions/salePerson/salePersonForm.action';
import { createSalepersonhierarchy, deleteSalepersonhierarchy, getAllSalepersonhierarchy, updateSalepersonhierarchy } from '../../redux/actions/salesPersonHierarchy.action.js';
const { TabPane } = Tabs;
const { Option } = Select;
const SalePersonHierarchy = ({ token }) => {
    TabTitle("Sale Person Hierarchy")
    const dispatch = useDispatch()
    const { country, userRights, log, salePersonForm, salePersonHierarchy } = useSelector(state => state)
    const [minimize, setMinimize] = useState(false);
    const [countryName, setCountryName] = useState('');
    const [formState, setFormState] = useState('view');
    const [form] = Form.useForm();
    const countryNameInput = useRef(null);
    const [disable, setDisable] = useState(false);
    const [salePersonHierarchyObj, setSalePersonHierarchyObj] = useState(null);
    const [check, setCheck] = useState(true);
    const id = ReadCookie('menuId')

    const [salePersonId, setSalePersonId] = useState(null);
    const [supervisorId, setSupervisorId] = useState(null);

    useEffect(() => {
        dispatch(loadSalePerson(token));
        dispatch(getAllSalepersonhierarchy(token));

    }, [token, dispatch])




    const handleDelete = () => {
        if (salePersonHierarchyObj) {

            dispatch(deleteSalepersonhierarchy(token, salePersonHierarchyObj.hierarchy_id)).then((res) => {
                if (res.type === "DELETE_SALESPERSON_HIERARCHY_SUCCESS") {
                    notification("success", "Sale Person Deleted", "Sale Person Deleted Successfully!");
                }
                if (res.type === "DELETE_SALESPERSON_HIERARCHY_ERROR") {
                    notification("error", res?.payload?.request?.statusText, res?.payload?.data?.data);
                }
                form.setFieldsValue({
                    sale_person_id: null,
                    supervisor_id: null,
                })

                setSalePersonId(null)
                setSupervisorId(null)
                setSalePersonHierarchyObj(null)
                setFormState('view')
                dispatch(getAllSalepersonhierarchy(token));
            })
        }
        setFormState("view")
    }



    useLayoutEffect(() => {
        dispatch(getRights(token, id)).then((res) => {
            if (res.type === "GET_USER_RIGHTS_SUCCESS") {
                if (!res?.payload.can_add) {
                    setFormState("table")
                }
            }
        });
    }, [])

    useEffect(() => {
        if (salePersonHierarchyObj) {
            setFormState('view')
            form.setFieldsValue({
                id: salePersonHierarchyObj.hierarchy_id,
                sale_person_id: salePersonHierarchyObj.sales_person_id,
                supervisor_id: salePersonHierarchyObj.manager_sales_person_id,
            });
            setSalePersonId(salePersonHierarchyObj.sales_person_id)
            setSupervisorId(salePersonHierarchyObj.manager_sales_person_id)
        }
    }, [salePersonHierarchyObj]);


    const formSave = () => {

        if (formState === "add") {

            dispatch(createSalepersonhierarchy(token, { sales_person_id: salePersonId, manager_sales_person_id: supervisorId })).then((res) => {
                console.log("res", res?.payload?.hierarchy_id)
                if (res.type === "CREATE_SALESPERSON_HIERARCHY_ERROR") {
                    notification("error", "Not Created", res?.payload?.data?.data)
                }
                if (res.type === "CREATE_SALESPERSON_HIERARCHY_SUCCESS") {
                    notification("success", "Sale Person", "Sale Person created successfully!");
                    form.setFieldsValue({
                        id: res?.payload?.hierarchy_id,
                        sale_person_id: null,
                        supervisor_id: null,
                    })
                    setFormState("edit")

                    setSalePersonId(null)
                    setSupervisorId(null)
                    setSalePersonHierarchyObj(null)

                }

                dispatch(getAllSalepersonhierarchy(token));

            })

        }
        if (formState === "edit") {
            dispatch(updateSalepersonhierarchy(token, { sales_person_id: salePersonId, manager_sales_person_id: supervisorId }, salePersonHierarchyObj.hierarchy_id)).then((res) => {

                if (res.type === "UPDATE_SALESPERSON_HIERARCHY_ERROR") {
                    notification("error", "Update", "Something went wrong")
                }
                if (res.type === "UPDATE_SALESPERSON_HIERARCHY_SUCCESS") {
                    notification("success", "Sale Person Updated", "Record updated successfully")
                }
                dispatch(getAllSalepersonhierarchy(token));
            })



        }
    }


    useEffect(() => {

        dispatch(getLog(token, { admin_country: "admin_country" }))
    }, [dispatch, token]);

    useEffect(() => {
        if (formState === "add") {

            // countryNameInput.current.focus();
            form.setFieldsValue({
                sale_person_id: null,
                supervisor_id: null,
            })
            // setCheck(true)
            // setCountryName("")
            // setsalePersonHierarchyObj(null)
        }
    }, [formState]);

    const filterReset = () => {
        setFormState("view")
        setSalePersonHierarchyObj(null)
        form.setFieldsValue({
            sale_person_id: null,
            supervisor_id: null,
        })
    }
    return <div className='styleContainer'>
        <div className='styleBody h-100' >
            <PageHeader title={"Sale Person Hierarchy"} minimize={setMinimize} check={minimize} />
            {
                !minimize &&
                <div className='bodyStyle' >
                    <div className='crudDiv' ><CrudButtons formType={formState} rights={userRights?.payload} formState={setFormState} reset={filterReset} disable={disable} save={formSave} onDelete={handleDelete} /></div>
                    <div className='styleContent' >
                        <Row className='tables-main-row-new' >
                            <Col xs={24} sm={24} md={10} lg={8} xl={6}>
                                <div className='styleTable' >
                                    <Tables type="salePersonHierarchy" formState={formState} scrollX={"20rem"} salePersonHierarchyObj={setSalePersonHierarchyObj} source={salePersonHierarchy?.payload?.data} col={salePersonHierarchyColumns} paginate scroll={602} perPage={25} load={salePersonHierarchy.loading} rowKey="sales_person_id
" />
                                </div>
                            </Col>
                            <Col xs={24} sm={24} md={14} lg={16} xl={18}>
                                <div className='styleForm'  >
                                    <div className='testStyle' >
                                        <Form
                                            form={form}
                                            name="basic"


                                        >
                                            <div className='customRow styleFormUpper ' >
                                                {salePersonHierarchyObj !== null && !(formState === "add") &&
                                                    <div className='customCols slc'>
                                                        <Form.Item
                                                            label="ID"
                                                            name="id"
                                                            initialValue={form.getFieldValue().id}
                                                            labelCol={{ span: 10 }}
                                                            wrapperCol={{ span: 14 }}

                                                        >
                                                            <Input size='small' className='styleInput id-field-style' readOnly />

                                                        </Form.Item>
                                                    </div>

                                                }

                                                <div className='customCols slc'>
                                                    <Form.Item
                                                        label="Sale Person"
                                                        name="sale_person_id"
                                                        initialValue={form.getFieldValue().supervisor_id}
                                                        labelCol={{ span: 10 }}
                                                        wrapperCol={{ span: 14 }}
                                                    >
                                                        <Select
                                                            size="small"
                                                            showSearch
                                                            optionFilterProp="children"
                                                            filterOption={(input, options) =>
                                                                options.children
                                                                    .toLowerCase()
                                                                    .indexOf(input.toLowerCase()) >= 0
                                                            }
                                                            disabled={!(formState === "add" || formState === "edit")}
                                                            className="styleInput w-100"
                                                            onChange={(val) => setSalePersonId(val)}
                                                        >
                                                            {salePersonForm?.payload?.data.map((item) => {
                                                                return (
                                                                    <Option key={item.sales_person_id} value={item.sales_person_id}>{item.salesperson_name}</Option>
                                                                );
                                                            })}
                                                        </Select>
                                                    </Form.Item>
                                                </div>
                                                <div className='customCols slc'>
                                                    <Form.Item
                                                        label="Supervisor"
                                                        name="supervisor_id"
                                                        initialValue={form.getFieldValue().supervisor_id}
                                                        labelCol={{ span: 10 }}
                                                        wrapperCol={{ span: 14 }}
                                                    >
                                                        <Select
                                                            size="small"
                                                            showSearch
                                                            optionFilterProp="children"
                                                            filterOption={(input, options) =>
                                                                options.children
                                                                    .toLowerCase()
                                                                    .indexOf(input.toLowerCase()) >= 0
                                                            }
                                                            disabled={!(formState === "add" || formState === "edit")}
                                                            className="styleInput w-100"
                                                            onChange={(val) => setSupervisorId(val)}
                                                        >
                                                            {salePersonForm?.payload?.data.map((item) => {
                                                                return (
                                                                    <Option key={item.sales_person_id} value={item.sales_person_id}>{item.salesperson_name}</Option>
                                                                );
                                                            })}
                                                        </Select>
                                                    </Form.Item>
                                                </div>

                                            </div>
                                        </Form>
                                    </div>

                                   
                                  

                                </div>

                            </Col>

                        </Row>
                    </div>
                </div>
            }
        </div>
    </div>
};

export default SalePersonHierarchy